module.exports = __webpack_public_path__ + "static/img/环保设备.11910fa1.png";